<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough" transform="matrix(-1,0,0,1,32,0)">
        <path
          d="M30.9333,0C31.522399999999998,0,32,0.477563,32,1.06667C32,1.06667,32,3.2,32,3.2C32,3.7891,31.522399999999998,4.26667,30.9333,4.26667C30.9333,4.26667,28.693199999999997,4.26732,28.693199999999997,4.26732C28.3586,5.91475,27.2646,7.28636,25.79247,8.00084C27.2649,8.71409,28.359,10.0859,28.6934,11.7338C28.6934,11.7338,30.9333,11.7333,30.9333,11.7333C31.522399999999998,11.7333,32,12.2109,32,12.8C32,12.8,32,14.9333,32,14.9333C32,15.5224,31.522399999999998,16,30.9333,16C30.9333,16,25.6,16,25.6,16C25.0109,16,24.53333,15.5224,24.53333,14.9333C24.53333,14.9333,24.53333,12.8,24.53333,12.8C24.53333,12.2109,25.0109,11.7333,25.6,11.7333C25.6,11.7333,27.599,11.7337,27.599,11.7337C27.1425,9.95939,25.57337,8.63164,23.67962,8.53856C23.67962,8.53856,23.46667,8.53333,23.46667,8.53333C23.46667,8.53333,23.46667,9.6,23.46667,9.6C23.46667,10.1891,22.9891,10.6667,22.4,10.6667C22.4,10.6667,17.06667,10.6667,17.06667,10.6667C16.477563,10.6667,16,10.1891,16,9.6C16,9.6,16,6.4,16,6.4C16,5.8109,16.477563,5.33333,17.06667,5.33333C17.06667,5.33333,22.4,5.33333,22.4,5.33333C22.9891,5.33333,23.46667,5.8109,23.46667,6.4C23.46667,6.4,23.46667,7.46667,23.46667,7.46667C25.45447,7.46667,27.1248,6.10731,27.5987,4.26748C27.5987,4.26748,25.6,4.26667,25.6,4.26667C25.0109,4.26667,24.53333,3.7891,24.53333,3.2C24.53333,3.2,24.53333,1.06667,24.53333,1.06667C24.53333,0.477563,25.0109,0,25.6,0C25.6,0,30.9333,0,30.9333,0C30.9333,0,30.9333,0,30.9333,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DataLineage',
} as DefineComponent
</script>
